import classNames from 'classnames';
import Link from './Link';

// Shared card of the broker-report-sync mock: `.card{background:var(--surface);border:1px solid var(--border);box-shadow:var(--shadow)}`.
const BASE = 'rounded-2xl border bg-surface shadow-card';

const BORDER = {
  default: 'border-border',
  interactive: 'border-border',
  danger: 'border-danger-border',
  warn: 'border-warn-border',
};

function Card({ variant = 'default', to, className, children, ...rest }) {
  const classes = classNames(BASE, BORDER[variant] || BORDER.default, className);

  if (variant === 'interactive') {
    const hover = classNames(classes, 'hover:bg-surface-alt transition-colors text-left');
    if (to) {
      return (
        <Link to={to} className={classNames('block', hover)} {...rest}>
          {children}
        </Link>
      );
    }
    return (
      <button type="button" className={classNames('block w-full', hover)} {...rest}>
        {children}
      </button>
    );
  }

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export default Card;
